import { useEffect, useState } from 'react';

import type { BreakpointName } from 'client-ribbons-base/constants/breakpoints';
import { minBreakpoints as breakpoints } from 'client-ribbons-base/constants/breakpoints';

const sortedBreakpoints = Object.entries(breakpoints).sort((a, b) => (a[1] >= b[1] ? 1 : -1));

interface UseBreakpointOptions {
  /** @deprecated replace the use of this option with expecting the initial value to be XS (render mobile-first) */
  initializeWithLarge?: boolean;
}

export const useBreakpoint = ({
  initializeWithLarge = false,
}: UseBreakpointOptions = {}): BreakpointName => {
  const [screen, setScreen] = useState<number>(
    initializeWithLarge ? breakpoints.XS : breakpoints.L,
  );

  useEffect(() => {
    const onResize = (): void => {
      setScreen(window.innerWidth);
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const result = sortedBreakpoints.reduce((acc, [name, width]) => {
    if (screen >= width) {
      return name;
    } else {
      return acc;
    }
  }, sortedBreakpoints[0][0]);

  return result as BreakpointName;
};
